import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useCreateVideoBulkMutation } from "../../redux/Api/VideoApiSlice";
import { Card, CardBody, CardFooter, CardHeader } from "../../components/other/card/card";
import { getUserId } from "../../helpers/auth";
import { toast } from "react-toastify";
import Loader from "../../pages/pages/loader";
import { cleanExcelFile } from "../other/cleanExcelFile";

const LinksInsertion = ({ platform_name, isContentID }) => {
  const [createVideoBulk, { isLoading, isSuccess }] = useCreateVideoBulkMutation();
  const filePicker = useRef(null);
  const [file, setFile] = useState(null);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      user: getUserId(),
      file: null,
    },
    validationSchema: Yup.object({
      file: Yup.mixed().required("Excel file is required"),
    }),
    onSubmit: async (values) => {
      if (!file) {
        toast.error("Please upload an Excel file first.");
        return;
      }

      try {
        toast.info("Cleaning Excel file before upload...");
        const cleanedFile = await cleanExcelFile(file, isContentID);

        const formData = new FormData();
        formData.append("file", cleanedFile);
        formData.append("user", values.user);

        toast.info("Uploading cleaned file, please wait...");
        await createVideoBulk(formData).unwrap();
      } catch (error) {
        if (error?.data) {
          const errorMessages = Object.values(error.data).flat();
          errorMessages.forEach((message) => toast.error(message));
        } else {
          toast.error("Failed to upload Excel file");
        }
      }
    },
  });

  useEffect(() => {
    if (isSuccess) {
      toast.success("Uploaded successfully!");
      handleReset(); 
    }
  }, [isSuccess]);

  const handleFile = (e) => {
    const uploadedFile = e.target.files?.[0];
    if (!uploadedFile) return;
    setFile(uploadedFile);
    validation.setFieldValue("file", uploadedFile);
  };

  const handleReset = () => {
    setFile(null);
    validation.resetForm();
    if (filePicker.current) {
      filePicker.current.value = ""; 
    }
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <Card>
        <CardHeader>Upload {platform_name} Result Sheet</CardHeader>
        <CardBody>
          <div className="mb-3">
            <label htmlFor="file">Upload xlsx file</label>
            <br />
            <input
              ref={filePicker}
              type="file"
              onChange={handleFile}
              accept=".xlsx, .xls"
              name="file"
              id="file"
            />
            {validation.errors.file && validation.touched.file && (
              <p className="text-danger mt-4">{validation.errors.file}</p>
            )}
            {file && (
              <p className="mt-2 text-success">
                Selected file: <strong>{file.name}</strong>
              </p>
            )}
          </div>
        </CardBody>
        <CardFooter>
          <div className="flex gap-4">
            <button
              type="submit"
              className="btn btn-outline-theme"
              onClick={validation.handleSubmit}
              disabled={isLoading}
            >
              Submit
            </button>
            <button
              type="button"
              className="btn btn-outline-warning"
              onClick={handleReset}
              disabled={isLoading}
            >
              Reset
            </button>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
};

export default LinksInsertion;
